var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ba2405234ed5f37c0355b4fa6bddb6173421a2f8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["can-you-unlock@can-you-unlock"]={id:"ba2405234ed5f37c0355b4fa6bddb6173421a2f8"};
      